import { ButtonUiState } from '@/components/Common/Button/ButtonUi';

export type DetailActionsUi = {
  acceptOrderButton?: ButtonUiState;
  deliveredOrderButton?: ButtonUiState;
  showCancelOrder?: boolean;
  showSendOrder?: boolean;
  showViewHistory?: boolean;
};

export const initialState: DetailActionsUi = {};
